module.exports = __webpack_public_path__ + "96428cc7f24a79ac7b955f31c4fd9f40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/amazon_com_2021_chart.png
// module id = 1629
// module chunks = 0